/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { Stack } from "@fluentui/react";
import * as React from "react";

import { CrossLocationShiftCard } from "../../../shift/shiftCards/CrossLocationShift/CrossLocationShiftCard";
import { MemberRequestList } from "../common/MemberRequestList/MemberRequestList";

import { getShiftProps } from "./CrossLocationRequestDetails.mappers";
import { getClassNames } from "./CrossLocationRequestDetails.styles";
import { CrossLocationRequestDetailsProps } from "./ICrossLocationRequestDetailsProps";

/**
 * Renders the Cross locaiton open shift request details and all those who have requested the shift.
 * @param props Props for the component.
 * @returns Cross Location Open Shift Request.
 */
export const CrossLocationRequestDetails: React.FC<CrossLocationRequestDetailsProps> = props => {
    const { shift, ...memberRequestListProps } = props;
    const styles = getClassNames();

    const shiftProps = getShiftProps(shift);
    return (
        <Stack className={styles.stack} tokens={{ childrenGap: 8 }}>
            <Stack.Item className={styles.shift}>
                {shiftProps ? (
                    <CrossLocationShiftCard {...shiftProps} />
                ) : null}
            </Stack.Item>
            <Stack.Item className={styles.member}>
                {memberRequestListProps?.requestList ? <MemberRequestList {...memberRequestListProps} /> : null}
            </Stack.Item>
        </Stack>
    );
};
